import * as Sentry from "@sentry/react";

/**
 * Initialize Sentry for crash reporting on the web beta.
 *
 * The DSN is injected at build time via VITE_SENTRY_DSN. Sentry's threat
 * model treats DSNs as public, so it's safe to embed in the browser bundle.
 *
 * Tracing and session replay are deliberately OFF — we want crash reports
 * only, not analytics. Each event is tagged with the Basic Auth username
 * (set via identifyTester once useUser resolves) and with the active mode
 * id when a mode is opened (set via tagActiveMode in App).
 */
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return; // Silently skip in local dev where no DSN is set.
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}

/** Tag every subsequent event with the Basic-Auth username. */
export function identifyTester(username: string): void {
  Sentry.setUser({ username });
}

/** Tag the currently active game mode (or clear it when returning to menu). */
export function tagActiveMode(modeId: string | null): void {
  Sentry.setTag("mode", modeId ?? "menu");
}
